import { useEffect } from 'react';

import './parallaxEffect.css'

export default function ParallaxEffect() {

    useEffect(() => {
        const onScroll = () => {
            const arrows = document.getElementById("arrows");
            if (arrows) arrows.style.visibility = "hidden";

            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop < 1000) {
                const layers = document.getElementsByClassName("parallax");

                for (let i = 0; i < layers.length; i++) {
                    const layer = layers[i];
                    const speed = layer.dataset.speed;
                    const yPos = -(scrollTop * speed) / 100;

                    layer.style.transform = `translate3d(0px, ${yPos}px, 0px)`;
                }
            }
        };

        window.addEventListener("scroll", onScroll);

        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);

    return (
        <div className="keyart" id="parallax">
            <img className="keyart_layer parallax" alt="Parallax background layer 0" id="keyart-0" data-speed="7" src="./firewatch/parallax0.png"/>
            <img className="keyart_layer parallax" alt="Parallax background layer 1" id="keyart-1" data-speed="10" src="./firewatch/parallax1.png"/>
            <img className="keyart_layer parallax" alt="Parallax background layer 2" id="keyart-2" data-speed="16" src={window.innerWidth < 600 ? "./firewatch/parallax2_little.png": "./firewatch/parallax2.png"}/>
            <img className="keyart_layer parallax" alt="Parallax background layer 3" id="keyart-3" data-speed="21" src="./firewatch/parallax3.png"/>
            <img className="keyart_layer parallax" alt="Parallax background layer 4" id="keyart-4" data-speed="21" src="./firewatch/parallax4.png"/>	
            <img className="keyart_layer parallax" alt="Parallax background layer 5" id="keyart-5" data-speed="41" src="./firewatch/parallax5.png"/>
            <img className="keyart_layer parallax" alt="Parallax background layer 6" id="keyart-6" data-speed="54" src="./firewatch/parallax6.png"/>
            <div className="keyart_layer" id="keyart-scrim"></div>
            <img className="keyart_layer parallax" alt="Parallax background layer 7" id="keyart-7" data-speed="69" src="./firewatch/parallax7.png"/>
            <img className="keyart_layer" alt="Parallax background layer 8" id="keyart-8" data-speed="100" src="./firewatch/parallax8.png"/>
        </div>
    )

}